import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { returnToLogin } from '../helpers';
import { ButtonSubmit } from '@app/components';
import Icon from '@app/components/Icon/index';

export const ChangePasswordSuccess = () => {
    const { translation } = useTypedTranslation();
    return (
      <div className='reset-password reset-password--success'>
          <div className='reset-password__icon-block'>
            <Icon icon='emailSentIco' className='reset-password__icon' />
          </div>
          <h1>{translation('RESET_TITLE_SUCCESS')}</h1>
          <div className='reset-password__text--success'>{translation('RESET_CHANGE_PASSWORD_MESSAGE')}</div>
          <div className='reset-password__buttons'>
              <ButtonSubmit
                className='reset-password__button'
                buttonText={translation('RESET_SIGN_IN')}
                disableRipple={true}
                onClick={returnToLogin()}
                isDisabled={false}
                isLoad={false}
              />
          </div>
      </div>
    );
};
